import { render } from "./InsidentForm.vue?vue&type=template&id=4f0ee78e"
import script from "./InsidentForm.vue?vue&type=script&lang=js"
export * from "./InsidentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__